/* =====================================================================
   WHOLESALE PRICING  →  assets/wholesale-pricing.js
   Laskee korin LISTASUMMAN (total_price + total_discount = ennen wholesale-
   alennusta) → aktiivisen alennusportaan → päivittää:
     1. progress barin (täyttö, portaat, viesti)
     2. checkout-reitin → /discount/{oikea kuponki}?redirect=/checkout
        (drawerin <a>-linkki JA cart-sivun checkout-napit)

   Kuponki päivitetään JOKA korimuutoksessa (updateAll kutsutaan aina kun
   cart:changed laukeaa tai /cart.js haetaan) → aktiivinen porras ⇒ oikea
   koodi aina. Kun kori laskee portaan alle, koodi vaihtuu pienempään;
   Shopifyn min-ostoraja on lisäturva ettei väärä koodi sovellu.

   TÄRKEÄÄ: portaat lasketaan listasummasta, EI pelkästä total_price:sta,
   jotta jo korissa oleva alennus ei tiputa laskentaa väärään portaaseen.

   Kuuntelee 'cart:changed' (cart-drawer.js / cart-sivu dispatchaa) sekä
   hakee /cart.js alustuksessa. Summat penneissä.
   ===================================================================== */
(function () {
  'use strict';

  var wraps = document.querySelectorAll('[data-wholesale-progress]');
  if (!wraps.length) return;

  function parseTiers(el) {
    try {
      return JSON.parse(el.getAttribute('data-wl-tiers') || '[]');
    } catch (e) { return []; }
  }

  /* Valuutta marketin mukaan — EI kovakoodattua GBP:tä.
     1) /cart.js -vastauksen cart.currency (asetetaan setCurrencyFromCart)
     2) Shopify.currency.active
     3) fallback 'GBP'
     Intl hoitaa symbolin, sijainnin ja erottimet valuutan mukaan. */
  var activeCurrency =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    'GBP';
  function setCurrencyFromCart(cart) {
    if (cart && cart.currency) activeCurrency = cart.currency;
  }
  var _fmtCache = {};
  function moneyFmt() {
    if (_fmtCache[activeCurrency]) return _fmtCache[activeCurrency];
    var f;
    try {
      f = new Intl.NumberFormat(undefined, { style: 'currency', currency: activeCurrency, currencyDisplay: 'symbol' });
    } catch (e) {
      f = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'GBP' });
    }
    _fmtCache[activeCurrency] = f;
    return f;
  }
  // Summa yksikköinä (esim. punnat/eurot, ei senttejä)
  function fmtMoney(amount) {
    return moneyFmt().format(Number(amount) || 0);
  }
  // Kynnyslabelit ilman desimaaleja (esim. €500 / £500)
  var _fmtRoundCache = {};
  function fmtMoneyRound(amount) {
    if (!_fmtRoundCache[activeCurrency]) {
      var f;
      try {
        f = new Intl.NumberFormat(undefined, { style: 'currency', currency: activeCurrency, currencyDisplay: 'symbol', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      } catch (e) {
        f = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      _fmtRoundCache[activeCurrency] = f;
    }
    return _fmtRoundCache[activeCurrency].format(Number(amount) || 0);
  }

  // Korkein porras jonka kynnys täyttyy
  function activeTier(tiers, pounds) {
    var hit = null;
    for (var i = 0; i < tiers.length; i++) {
      if (pounds >= tiers[i].min) hit = tiers[i];
    }
    return hit;
  }
  // Seuraava saavuttamaton porras
  function nextTier(tiers, pounds) {
    for (var i = 0; i < tiers.length; i++) {
      if (pounds < tiers[i].min) return tiers[i];
    }
    return null;
  }

  function renderMarkers(el, tiers, pounds, max) {
    var html = '';
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var pos = max > 0 ? (t.min / max) * 100 : 0;
      var hit = pounds >= t.min ? ' wp-tier--hit' : '';
      html += '<div class="wp-tier' + hit + '" style="left:' + pos + '%">' +
        '<span class="wp-tier__dot"></span>' +
        '<span class="wp-tier__amt">' + fmtMoneyRound(t.min) + '</span>' +
        '<span class="wp-tier__pct">' + t.pct + '%</span>' +
        '</div>';
    }
    el.innerHTML = html;
  }

  // Rakenna checkout-reitti aktiivisen portaan mukaan.
  // Aktiivinen porras määrää kupongin (RETAILER30 jne.); jos mikään porras
  // ei täyty → tavallinen /checkout ilman kuponkia.
  function checkoutHref(root, tier) {
    var base = (root || '/').replace(/\/$/, '');
    if (tier) {
      return base + '/discount/' + encodeURIComponent(tier.code) + '?redirect=/checkout';
    }
    return base + '/checkout';
  }

  // Vie aktiivinen checkout-reitti drawerin linkkiin JA cart-sivun nappeihin.
  // Kutsutaan joka korimuutoksessa (updateAll), jotta kuponki on aina oikea.
  function applyCheckoutRoute(href) {
    if (!href) return;
    // Drawerin checkout-linkki (<a>)
    var drawerLinks = document.querySelectorAll('.cart-drawer__checkout');
    for (var i = 0; i < drawerLinks.length; i++) {
      drawerLinks[i].setAttribute('href', href);
    }
    // Cart-sivun checkout-napit (<button name="checkout"> lomakkeessa).
    // Merkitään data-attribuutilla → klikkikaappaus ohjaa discount-URLiin.
    var pageBtns = document.querySelectorAll('.cart-page__checkout, .cart-page__bar-checkout');
    for (var j = 0; j < pageBtns.length; j++) {
      pageBtns[j].setAttribute('data-wl-checkout', href);
    }
  }

  // Kirjoita säästö-badge JA alennettu välisumma itse. Rivit pysyvät
  // täyshintaisina (Shopify hoitaa), mutta välisumma = listasumma − wholesale.
  function writeTotals(listCents, pct) {
    var savingCents = Math.round(listCents * (pct / 100));
    var subtotalCents = listCents - savingCents;

    // Säästörivit (drawer + cart-sivu)
    var rows = document.querySelectorAll('[data-cart-savings]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var amtEl = row.querySelector('[data-cart-savings-amt]');
      var pctEl = row.querySelector('[data-cart-savings-pct]');
      if (pct > 0 && savingCents > 0) {
        if (amtEl) amtEl.textContent = fmtMoney(savingCents / 100);
        if (pctEl) { pctEl.textContent = '-' + pct + '%'; pctEl.hidden = false; }
        row.hidden = false;
      } else {
        row.hidden = true;
      }
    }

    // Välisumma (drawer + cart-sivu + mobiilipalkki): alennettu summa
    var subEls = document.querySelectorAll('[data-cart-subtotal], [data-cart-bar-amt]');
    for (var j = 0; j < subEls.length; j++) {
      subEls[j].textContent = fmtMoney(subtotalCents / 100);
    }
  }

  // Listasumma wholesale-portaita varten. Käytä Shopifyn omaa
  // items_subtotal_price -kenttää: rivien summa rivikohtaisten alennusten
  // JÄLKEEN mutta ennen kori-/kuponkitason alennuksia. Tämä on oikea peruste
  // portaalle ja täsmää tuoterivien summaan. Fallback vanhoille cart-objekteille.
  function listSubtotalCents(cart) {
    if (typeof cart.items_subtotal_price === 'number') return cart.items_subtotal_price;
    if (cart.items && cart.items.length) {
      var s = 0;
      for (var i = 0; i < cart.items.length; i++) {
        s += (cart.items[i].final_line_price || cart.items[i].line_price || 0);
      }
      return s;
    }
    return cart.total_price || 0;
  }

  function updateAll(cart) {
    setCurrencyFromCart(cart);
    var listCents = listSubtotalCents(cart);
    var pounds = listCents / 100;
    var routeHref = null;
    var activePct = 0;
    for (var w = 0; w < wraps.length; w++) {
      var wrap = wraps[w];
      var role = wrap.getAttribute('data-wl-role');
      var root = wrap.getAttribute('data-wl-checkout-base') || '/';
      var tiers = parseTiers(wrap);
      var active = activeTier(tiers, pounds);
      if (active) activePct = active.pct;

      // Aktiivisen portaan mukainen checkout-reitti (kaikki roolit, myös fitter)
      routeHref = checkoutHref(root, active);

      if (role !== 'fitter') {
        var totalEl = wrap.querySelector('[data-wl-total]');
        var fillEl  = wrap.querySelector('[data-wl-fill]');
        var msgEl   = wrap.querySelector('[data-wl-msg]');
        var mkEl    = wrap.querySelector('[data-wl-markers]');
        var max = tiers.length ? tiers[tiers.length - 1].min : 0;

        if (totalEl) totalEl.textContent = fmtMoney(pounds) + ' eligible';

        // Todellinen etenemä (ei boostattu)
        var fill = max > 0 ? Math.min(100, (pounds / max) * 100) : 0;
        if (fillEl) fillEl.style.width = fill + '%';

        if (mkEl) renderMarkers(mkEl, tiers, pounds, max);

        if (msgEl) {
          var nxt = nextTier(tiers, pounds);
          if (active && nxt) {
            var gap = nxt.min - pounds;
            msgEl.className = 'wp-msg wp-msg--active';
            msgEl.innerHTML = '<span class="wp-badge">' + active.pct + '% off</span>' +
              fmtMoney(gap) + ' more \u2192 <strong>' + nxt.pct + '%</strong>';
          } else if (active && !nxt) {
            msgEl.className = 'wp-msg wp-msg--max';
            msgEl.innerHTML = '<span class="wp-badge wp-badge--max">' + active.pct + '% off</span>Max discount unlocked';
          } else if (nxt) {
            msgEl.className = 'wp-msg';
            msgEl.innerHTML = fmtMoney(nxt.min - pounds) + ' more to unlock <strong>' + nxt.pct + '% off</strong>';
          } else {
            msgEl.className = 'wp-msg';
            msgEl.innerHTML = '';
          }
        }
      }
    }

    // Päivitä checkout-reitti (oikea kuponki) joka korimuutoksessa
    applyCheckoutRoute(routeHref);
    // Säästö-badge lasketaan itse (listasumma × aktiivinen porras-%)
    writeTotals(listCents, activePct);
  }

  // Klikkikaappaus cart-sivun napeille (delegaatio): ohjaa discount-URLiin
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wl-checkout]') : null;
    if (!btn) return;
    var href = btn.getAttribute('data-wl-checkout');
    if (!href) return;
    e.preventDefault();
    window.location.href = href;
  });

  function fetchAndUpdate() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateAll(cart); })
      .catch(function () {});
  }

  // cart-drawer.js / cart-sivu dispatchaa cart-objektin renderin jälkeen.
  // Jos detail on täysi cart (items mukana), käytä sitä; muuten hae tuoreena.
  document.addEventListener('cart:changed', function (e) {
    if (e.detail && e.detail.items) {
      updateAll(e.detail);
    } else {
      fetchAndUpdate();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndUpdate);
  } else {
    fetchAndUpdate();
  }
})();